import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'liberro-show-more-link',
  standalone: false,
  templateUrl: './liberro-show-more-link.component.html',
  styleUrl: './liberro-show-more-link.component.less'
})
export class LiberroShowMoreLinkComponent {

  @Input() public label = '';
  @Input() public prefixIcon = '';
  @Input() public suffixIcon = '';
  @Input() public link = '';
  @Output() public linkClicked = new EventEmitter<void>();

  public readonly iconsPath = 'assets/icons/';

  public showMore(): void {
    this.linkClicked.emit();
  }

}
